import axiosInstance from "@API/axios";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setUser } from "@Redux/userSlice";
import { useNavigate } from "react-router";
import { USER_LOGIN_URL } from "@API/APIRoutes";

const useLogin = (userInput) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    const login = async () => {
      setError(false);
      setLoading(true);
      try {
        const response = await axiosInstance.post(USER_LOGIN_URL, {
          email: userInput.email,
          password: userInput.password,
        });
        console.log("response", response);
        sessionStorage.setItem("token", response.data.token);
        dispatch(
          setUser({
            email: userInput.email,
            username: response.data.username,
            role: response.data.roles[0],
            isLogged: true,
            userId: response.data.id,
            regions: response.data.regions || [], // Optional region field
            categories: response.data.categories || [], // Optional categories field
            managerEmail: response.data.managerEmail || null, // Optional manager email field
          })
        );
        setLoading(false);
        navigate("/home");
      } catch (error) {
        setError(true);
        setLoading(false);
      }
    };

    if (userInput) {
      login();
    }
  }, [userInput, dispatch, navigate]);
  return { loading, error };
};
export default useLogin;
